
export class Player {
  private playbackNode: AudioWorkletNode | null = null;
  private isPlayerRunning: boolean = false;

  async init(sampleRate: number) {
    const audioContext = new AudioContext({ sampleRate });
    await audioContext.audioWorklet.addModule("playback-worklet.js");

    this.playbackNode = new AudioWorkletNode(audioContext, "playback-worklet");
    this.playbackNode.connect(audioContext.destination);
  }

  play(buffer: Int16Array) {
    if (this.playbackNode) {
      this.playbackNode.port.postMessage(buffer);
      this.isPlayerRunning = true;
    }
  }
  

  clear() {
    if (this.playbackNode) {
      this.playbackNode.port.postMessage(null);
      this.isPlayerRunning = false;
    }
  }
  
  isCurrentlyPlaying(): boolean{
    return this.isPlayerRunning;
  }
}